<div *ngIf="schools && schoolProfile" class="container-fluid dashboard-body">
  <div class="profile-header">
    <h1 class="dashboard-title">{{ kpiservice.title }}</h1>
    <ng-select
      [items]="schoolsForDropdown"
      bindLabel="text"
      (change)="selected($event)"
      [(ngModel)]="selectedSchool"
      placeholder="No school selected"
      [clearable]="false"
      [searchable]="true"
      class="schools-dropdown"
      *ngIf="schoolsForDropdown.length > 1"
    ></ng-select>
  </div>
  <div *ngFor="let panel of schoolProfile.customerFramework?.customerPanels">
    <panel
      [metadata]="panel"
      [level]="schoolProfile.entityLevel"
      [entityId]="schoolId"
      [role]="role"
      [hasAllSchools]="hasAllSchools"
      [tier]="tier"
      [useRealTimeSchoolProfileRequest]="useRealTimeSchoolProfileRequest"
    ></panel>
  </div>
</div>
